<template>
  <div class="my-purchases-template" theme>
    <div id="theme-my-purchases-header" />
    <div id="theme-my-purchases-leftside" />
    <div id="theme-my-purchases-content" />
    <div id="theme-my-purchases-rightside" />
    <div id="theme-my-purchases-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'my-purchases',
      parts: [
        {
          elem: '#theme-my-purchases-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-my-purchases-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-my-purchases-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-my-purchases-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-my-purchases-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.my-purchases-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
